module.exports = __webpack_public_path__ + "img/a_3.36921b47.png";